//@vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

//@commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

// @ utilities
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');

class SendN1PasswordSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
    }

    handleEndInteraction() {
        this.props.history.push(`/disasterRecovery/customerFinder`);
    }

    render() {
        const title = formatText('wizardSuccess-successTitle');
        const subTitle = formatText('wizardSuccess-successSubTitle');
        const textLink = formatText('addImposition-disasterRecoveryConfirmationBackbtn');

        return (
            <article className="card-activator-success">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle={subTitle}
                    textLink={isDisasterRecoveryMode() ? textLink : '  '}
                    goBackHandler={isDisasterRecoveryMode() ? this.handleEndInteraction : () => {}}
                />
            </article>
        );
    }
}

SendN1PasswordSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(SendN1PasswordSuccessStep);
